module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {
        return _vm.handleClick(_vm.activeName)
      }
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "处理中",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已处理",
      "name": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 派送列表")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', [_vm._v("发货单号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "输入运单号/订单编号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("用户名/ViP号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "输入用户名/vip号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("派送编号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "请输入派送编号",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.deliveryNumber),
      callback: function($$v) {
        _vm.deliveryNumber = $$v
      },
      expression: "deliveryNumber"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("批次:\n        "), _c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.deliveryBatch),
      callback: function($$v) {
        _vm.deliveryBatch = $$v
      },
      expression: "deliveryBatch"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getDeliveryList()
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getDeliveryList('select')
      }
    }
  }, [_vm._v("查 询")])], 1), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainList,
      "border": "",
      "max-height": "550px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryNumber",
      "label": "派送编号",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "运单",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + " 个运单\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vip号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendNo",
      "label": "发货单号",
      "align": "center",
      "width": "140px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendRemark",
      "label": "批次",
      "align": "center",
      "width": "140px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "status_text"
        }, [(scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#1e90ff"
          }
        }, [_vm._v("\n              已处理\n            ")]) : (scope.row.status == 0) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("待处理")])]) : (scope.row.status == 1) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ffd700"
          }
        }, [_vm._v("处理中")])]) : (scope.row.status == -1) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ff6347"
          }
        }, [_vm._v("已取消")])]) : (scope.row.status == 3) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ff6347"
          }
        }, [_vm._v("已取消")])]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "派送费",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "width": "120px",
      "label": "发货单总费用",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "提出时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.changeDate(scope.row, 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "volume",
      "label": "体积CBM",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productWeight",
      "label": "重量KG",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unMixingTank",
      "label": "箱数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mixingTank",
      "label": "混箱数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "收货人电话",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "收货地址",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预计派送时间",
      "prop": "expectTime",
      "min-width": "160px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.expectTime) ? _c('span', [_vm._v(_vm._s(_vm.changeToTime(scope.row.expectTime)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDia(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showAccountDia(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showOrder(scope.row)
            }
          }
        }, [_vm._v("订单详情")]), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onLook(scope.row)
            }
          }
        }, [_vm._v("发货单详情")]), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateAddress(scope.row)
            }
          }
        }, [_vm._v("地址修改")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == 4) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编 辑",
      "visible": _vm.editDialog,
      "width": "60%",
      "center": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, _vm._l((_vm.editLsit), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "diaBox"
    }, [_c('div', {
      staticClass: "dialog_left diaBoxIn"
    }, [_c('div', {
      staticClass: "dialog_left_top diaStyle"
    }, [_c('div', {
      staticClass: "dialog_left_top1",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              发货单号：" + _vm._s(item.sendNo) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("\n              提交时间：" + _vm._s(item.createTime ? _vm.changeDate(item, 1) : "时间未知") + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_center diaStyle",
      staticStyle: {
        "border-top": "2px solid black"
      }
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("客户名称：" + _vm._s(item.userName))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("贵宾号：" + _vm._s(item.vipCode))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("总运费：CAD " + _vm._s(item.amount))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("备注： 未含加拿大出库后的派送费用")]), _vm._v(" "), _c('p', [_vm._v("客户需求： "), _c('span', [_vm._v("派送")])])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_center diaStyle",
      staticStyle: {
        "border-top": "2px solid black"
      }
    }, [_c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("派送地址：" + _vm._s(item.address))]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("派送电话：" + _vm._s(item.mobile))]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_c('span', [_vm._v("总体积：" + _vm._s(item.volume))]), _vm._v(" "), _c('span', {
      staticClass: "rightSpan"
    }, [_vm._v("总重量：" + _vm._s(item.productWeight))])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_c('span', [_vm._v("特混箱数：" + _vm._s(item.mixingTank))]), _vm._v(" "), _c('span', {
      staticClass: "rightSpan"
    }, [_vm._v("箱数：" + _vm._s(item.unMixingTank))])])]), _vm._v(" "), _c('div', {
      staticClass: "diaStyle",
      staticStyle: {
        "border-top": "solid"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              订单状态：\n              "), _c('el-select', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "clearable": "",
        "placeholder": "订单状态",
        "size": "small",
        "disabled": _vm.isDisabledStatus == 2
      },
      on: {
        "change": function($event) {
          return _vm.init()
        }
      },
      model: {
        value: (_vm.status.statusType),
        callback: function($$v) {
          _vm.$set(_vm.status, "statusType", $$v)
        },
        expression: "status.statusType"
      }
    }, _vm._l((_vm.statusTypeSelect), function(item) {
      return _c('el-option', {
        key: item.statusType,
        attrs: {
          "label": item.statusName,
          "value": item.statusType
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 0 15px -26px"
      }
    }, [_c('el-form', {
      ref: "RuleForm",
      refInFor: true,
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.ruleForm,
        "rules": _vm.rules,
        "label-width": "100px",
        "label-position": "right"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "派送费用 :",
        "prop": "price"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "number",
        "clearable": "",
        "size": "small",
        "disabled": _vm.isDisabledStatus == 2
      },
      model: {
        value: (_vm.ruleForm.price),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, "price", $$v)
        },
        expression: "ruleForm.price"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              预计派送时间："), _c('el-date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "type": "datetime",
        "size": "small",
        "picker-options": _vm.pickerOptions,
        "placeholder": "选择派送时间",
        "disabled": _vm.isDisabledStatus == 2
      },
      model: {
        value: (_vm.expectTime),
        callback: function($$v) {
          _vm.expectTime = $$v
        },
        expression: "expectTime"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              余额：CAD\n              "), _c('span', {
      staticStyle: {
        "color": "#ffa500"
      }
    }, [_vm._v("\n                " + _vm._s(item.balance) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              备注：\n              "), _c('div', {
      staticStyle: {
        "margin-top": "6px"
      }
    }, [_vm._v("1. 加拿大出库后的派送上门费用")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "6px"
      }
    }, [_vm._v("\n                2. 派送状态为已处理时派送费用才有效\n              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin": "36px 0 0 0"
      }
    }, [_c('el-button', {
      attrs: {
        "disabled": _vm.isDisabledStatus == 2,
        "type": "primary"
      },
      on: {
        "click": _vm.updateDelivery
      }
    }, [_vm._v("\n                提 交\n              ")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_right diaBoxIn"
    }, [_c('div', {
      staticClass: "dialog_right_text",
      staticStyle: {
        "text-align": "center",
        "border-bottom": "2px solid black"
      }
    }, [_vm._v("\n            反馈记录\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "dia_Text"
    }, [_c('div', {
      staticClass: "dia_Text_content"
    }, _vm._l((_vm.feedbackList), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "content_text"
      }, [(item.type == 1) ? _c('div', {}, [_c('div', [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.changeDate(item.operatorTime, 4)) + "\n                    ")])]), _vm._v(" "), _c('span', [_c('el-avatar', {
        attrs: {
          "size": "medium",
          "src": "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block",
          "margin": "-30px 0 0 43px"
        }
      }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
        staticStyle: {
          "position": "relative",
          "text-align": "right"
        }
      }, [_c('div', [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.changeDate(item.operatorTime, 4)) + "\n                    ")])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "position": "absolute",
          "right": "40px",
          "top": "28px"
        }
      }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]), _vm._v(" "), _c('span', [_c('el-avatar', {
        attrs: {
          "size": "medium",
          "src": "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        }
      })], 1)]) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "dia_Text_input"
    }, [_c('el-button', {
      staticClass: "refresh el-icon-refresh-right",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.getFeedbackList(1)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "dinput",
      attrs: {
        "id": "diaBt",
        "clearable": ""
      },
      nativeOn: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.postDeliveryFeedback($event)
        }
      },
      model: {
        value: (_vm.content),
        callback: function($$v) {
          _vm.content = $$v
        },
        expression: "content"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "dbt",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.postDeliveryFeedback
      }
    }, [_c('span', {
      staticClass: "send"
    }, [_vm._v("发 送")])])], 1)])])])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "出库结算",
      "visible": _vm.accountDia,
      "width": "60%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.accountDia = $event
      }
    }
  }, _vm._l((_vm.accountList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BigBox"
    }, [_c('div', {
      staticClass: "accountDia-content-header"
    }, [_c('div', {
      staticClass: "content-left content-left-text"
    }, [_c('div', [_vm._v("\n            发货单号:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.sendNo) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            预约状态:\n            "), _c('span', {
      staticStyle: {
        "color": "rgb(9, 157, 255)"
      }
    }, [_vm._v(" 已预约 ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-center content-left-text"
    }, [_c('div', [_vm._v("\n            VIP号:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.user.vipCode) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            入库时间:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.operatorTime ?
      _vm.changeDate(item.operatorTime, 4) :
      "无法显示") + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-left-text"
    }, [_c('div', [_vm._v("\n            客户:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.user.realName) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            订单数量: "), _c('span', [_vm._v(_vm._s(item.orderPojoList.length))])])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "36%",
        "float": "left",
        "margin-right": "20px"
      }
    }, [_vm._v("\n          所需总运费："), _c('span', [_vm._v(_vm._s(item.totalFreight))])]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "36%",
        "float": "left"
      }
    }, [_vm._v("\n          所需总派送费："), _c('span', [_vm._v(_vm._s(item.deliveryPrice))])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n        所需总工单费用："), _c('span', [_vm._v(_vm._s(item.totalWorkOrderFee))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer1",
      staticStyle: {
        "width": "100%",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "32%",
        "float": "left",
        "margin-right": "6px"
      }
    }, [_vm._v("\n          额外费用："), _c('span', [_vm._v(_vm._s(item.extraPrice))]), _vm._v(" CAD\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "32%",
        "float": "left",
        "margin-right": "6px"
      }
    }, [_vm._v("\n          最后总费用："), _c('span', [_vm._v(_vm._s(item.totalCost))]), _vm._v(" CAD\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "32%",
        "float": "left"
      }
    }, [_vm._v("\n          账户余额：\n          "), _c('span', {
      staticStyle: {
        "color": "#d2691e"
      }
    }, [_vm._v(_vm._s(item.user.balance))]), _vm._v(" CAD\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer2",
      staticStyle: {
        "width": "100%",
        "margin-top": "30px",
        "text-align": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "46%",
        "font-size": "17px",
        "font-weight": "bolder"
      }
    }, [_vm._v("\n          订单列表\n        ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "margin": "25px 0 -20px 0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "table"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listRow
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "label": "#",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productName",
        "align": "center",
        "label": "物品"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "orderNo",
        "label": "运单号",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productNum",
        "align": "center",
        "label": "数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "label": "货运类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n            ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goodType",
        "align": "center",
        "label": "用户"
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(_vm.accountList[0].user.realName) + "\n            ")])]), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "total",
        "align": "center",
        "label": "运费（CAD）"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "demandMoney",
        "align": "center",
        "label": "工费（CAD）"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "accountDia-footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.settlementBt()
        }
      }
    }, [_vm._v("确认结算")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          _vm.accountDia = false
        }
      }
    }, [_vm._v("取 消")])], 1)])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.listDia,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.listDia = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.listDia = false
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "diaText"
  }, [_c('div', {
    staticClass: "e_text"
  }, [_vm._v("发货单号：" + _vm._s(_vm.orderMsg.sendNo))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("订单数量：" + _vm._s(_vm.orderMsg.orderCount))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("相关用户VIP：" + _vm._s(_vm.user.vipCode))])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "max-height": "300px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "名称",
      "align": "center",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货物类型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.realName) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.vipCode) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价格",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(9, 157, 255)"
    }
  }, [_vm._v(" 已预约 ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "width": "180"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.deliveryTitle) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "运费(CAD)",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "align": "center",
      "width": "240px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.changeDate(scope.row.storeTime, 4)) + "\n          ")]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "160px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rate !== true) ? _c('span', [_vm._v(_vm._s(scope.row.rate))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "width": "220px",
      "align": "center"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isUpdateFeeShow,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isUpdateFeeShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("额外费用 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入修改后的费用",
      "autofocus": ""
    },
    model: {
      value: (_vm.feeInput),
      callback: function($$v) {
        _vm.feeInput = $$v
      },
      expression: "feeInput"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        备注 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入额外费用备注",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdateDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdateDialog
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialog.updaAddDia,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "updaAddDia", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("收货人电话 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入收货人电话",
      "autofocus": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        收货人地址 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入收货人地址",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdaAddDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdaAddDialog
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebb18ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/delivery/deliveryList.vue
// module id = 1246
// module chunks = 2